import { createSelector } from '@ngrx/store';
import { getMemberInterface } from '../getMemberInterface/get-member-interface.selector';

export const getMemberInterfaceUserData = createSelector(getMemberInterface, (memberInterface) => memberInterface.userData);
